<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg">{{ oopt.name }} - {{ reportOopt.reportName }} {{ reportOopt.reportYear }}</h1>
    <div class="history-report">
      <v-menu
        v-model="historyDialog"
        :close-on-content-click="false"
        :nudge-width="200"
        offset-y
      >
        <template v-slot:activator="{ on }">
          <a v-on="on"
          ><v-icon class="icon-history">history</v-icon>{{ $t('История') }}</a
          >
        </template>
        <v-list dense class="history-list history-list-table">
          <v-list-item
            two-line
          >
            <v-list-item-content>
              <div class="table-overflow">
                <table>
                  <tbody>
                  <tr
                    v-for="history in histories"
                    :key="'history_'+history.id"
                  >
                    <td>{{ new Date(history.createdDate) | dateFormat('DD.MM.YYYY') }}</td>
                    <td>{{ history.transStatusName }}</td>
                    <td>{{ history.userShortFio }}</td>
                    <td>{{ history.comment }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <div class="reports-pg">
      <Nat1
        v-if="reportIds.nat_1 === reportOopt.reportId"
        :reportOoptId="reportOoptId"
        :reportOopt="reportOopt"
        :editable.sync="editable"
        :ooptData="oopt"
      />
      <Tp2
        v-if="reportIds.tp_2 === reportOopt.reportId"
        :reportOoptId="reportOoptId"
        :reportOopt="reportOopt"
        :editable.sync="editable"
        :ooptData="oopt"
      />
      <div class="reports-footer form-action">
        <template v-for="actionPermission in actionPermissions">
          <v-btn
            :key="actionPermission.id"
            @click="action(actionPermission)"
            :class="actionPermission.class"
          >
            {{ actionPermission.name }}
          </v-btn>
          <template v-if="actionPermission.type == 'report_status' && actionPermission.comment === true">
            <v-dialog
              v-model="commentDialog[actionPermission.id]"
              scrollable
              max-width="600px"
              :key="'action_'+actionPermission.id"
            >
              <v-card class="modal observer-modal">
                <div class="modal-head">
                  {{ $t('Добавление комментария') }}
                  <v-btn color="modal-close" @click="changeCommentDialog(actionPermission.id, false)">
                    <img src="@/assets/img/close-icon.png" alt="icon">
                  </v-btn>
                </div>
                <div class="modal-body">
                  <v-row>
                    <v-col cols="4" md="4" class="input-label">
                      <v-label>
                        {{ $t('Комментарий') }}:
                      </v-label>
                    </v-col>
                    <v-col class="input-field">
                      <v-textarea
                        v-model="comment"
                        outlined
                        dense
                        clearable
                      />
                    </v-col>
                  </v-row>
                  <div class="form-action">
                    <button
                      class="btn btn-default blue"
                      type="button"
                      @click="changeStatus({ id: actionPermission.id, comment: comment }), changeCommentDialog(actionPermission.id, false)"
                    >
                      {{ $t('Добавить') }}
                    </button>
                    <button
                      class="btn btn-default gray"
                      type="button"
                      @click="changeCommentDialog(actionPermission.id, false)"
                    >
                      {{ $t('Отмена') }}
                    </button>
                  </div>
                </div>
              </v-card>
            </v-dialog>
          </template>
        </template>
      </div>
    </div>
  </v-container>
</template>

<script>
import Nat1 from '@/components/report/Nat1'
import Tp2 from '@/components/report/Tp2'
import Report from '@/model/report'
import { mapMutations } from 'vuex'

export default {
  components: {
    Nat1,
    Tp2
  },
  data: () => ({
    oopt: {},
    breadcrumbs: [],
    backUrl: process.env.VUE_APP_BACK_URL,
    reportOoptId: null,
    reportOopt: {},
    reportIds: [],
    actionPermissions: {},
    editable: false,
    commentDialog: [],
    comment: null,
    histories: [],
    historyDialog: false
  }),
  watch: {
    $route: 'fetchData'
  },
  created () {
    this.fetchData()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData () {
      this.setLoading(true)
      this.reportOoptId = Number(this.$route.params.id)
      Report.getReportOopt(this.$route.params.id).then((response) => {
        this.reportOopt = response.data.reportOopt
        this.reportIds = response.data.reportIds
        this.oopt = response.data.oopt
        this.histories = response.data.histories
        this.breadcrumbs = [
          { text: this.$i18n.t('Главная'), disabled: false, href: '/' },
          { text: this.$i18n.t('Рабочий кабинет'), disabled: false, href: '/my-organization' },
          { text: this.$i18n.t('Нацстатотчеты'), disabled: false, href: '/reports/all' },
          { text: this.oopt.name + ' - ' + this.reportOopt.reportName + ' ' + this.reportOopt.reportYear, disabled: true }
        ]
        this.getActions(this.reportOopt.statusId)
        this.setLoading(false)
      })
        .catch((error) => {
          this.$router.push({
            name: 'error',
            params: {
              status: error.response.status
            }
          })
          this.setLoading(false)
        })
    },
    // список действий
    getActions (statusId) {
      Report.getActions(statusId).then((response) => {
        this.actionPermissions = response.data
      })
    },
    // действия
    action (actionPermission) {
      if (actionPermission.type === 'report_status') {
        if (actionPermission.comment === true) {
          this.changeCommentDialog(actionPermission.id, true)
        } else {
          this.changeStatus({ id: actionPermission.id })
        }
        this.editable = false
        return
      }
      if (actionPermission.type === 'report_edit') {
        this.editable = true
        return
      }
      if (actionPermission.type === 'report_cancel') {
        this.editable = false
        this.fetchData()
      }
    },
    changeStatus (data) {
      Report.changeStatus(this.reportOopt.id, data)
        .then((response) => {
          this.reportOopt.statusId = response.data.statusId
          this.reportOopt.statusName = response.data.statusName
          this.histories = response.data.histories
          this.getActions(this.reportOopt.statusId)
        })
        .catch(() => {
          this.$noty.warning(this.$i18n.t('Ошибка'), {
            killer: true,
            timeout: 1000,
            layout: 'topRight'
          })
        })
    },
    // изменение статуса модального окна для комментариев
    changeCommentDialog (id, flag) {
      this.comment = null
      this.$set(this.commentDialog, id, flag)
    }
  }
}
</script>
